/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { AuthContext } from '../../../../modules/auth/components/AuthProvider'
import RequirePerm from '../../../../modules/auth/components/RequirePerm'
import { getSignInLink, getSignOutLink } from '../../../../modules/auth/lib/authLinks'
import { Menu, UnstyledButton } from '@mantine/core'
import { Link } from 'react-router-dom'
import UserAvatar from '../../../../modules/user/components/UserAvatar'
import AnchorLink from '../AnchorLink'
import { useDisclosure } from '@mantine/hooks'
import VersionNotesModal from '../../../../modules/twh/components/version/VersionNotesModal'

function UserMenu () {
  const auth = useContext(AuthContext)
  const [versionNotes, { toggle }] = useDisclosure()

  return auth.signedIn
    ? <Menu>
      <Menu.Target>
        <UnstyledButton>
          <UserAvatar
            name={auth.context?.username}
            variant="outline"
            color="primary"
          />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown maw={200}>
        <RequirePerm
          permissions={['access:admin']}
          render={() => (
            <>
              <Menu.Item
                component={Link}
                to="/admin"
              >
                <FormattedMessage
                  id="administration"
                  defaultMessage="Administration"
                />
              </Menu.Item>
              <Menu.Item onClick={toggle}>
                <FormattedMessage
                  id="version_notes"
                  defaultMessage="Notes de version"
                />
              </Menu.Item>
              <Menu.Divider />
            </>
          )}
        />
        <Menu.Item
          component={Link}
          to={getSignOutLink()}
        >
          <FormattedMessage
            id="sign_out"
            defaultMessage="Se déconnecter"
          />
        </Menu.Item>
      </Menu.Dropdown>

      <VersionNotesModal
        onClose={toggle}
        opened={versionNotes}
      />
    </Menu>
    : <AnchorLink to={getSignInLink()}>
      <FormattedMessage
        id="sign_in"
        defaultMessage="Connexion"
      />
    </AnchorLink>
}

export default UserMenu
